import { gql } from '@apollo/client';

export default gql`
  query GetSeatsProratedPriceByToken($token: String!, $seats: Int!, $subscriptionId: MongoID!) {
    getSeatsProratedPriceByToken(token: $token, seats: $seats, subscriptionId: $subscriptionId) {
      proratedPrice
      period
    }
  }
`;
